import React from "react";
//#region types
import { NumberFormatCustomProps } from "models/propTypes/inputPropTypes";
//#endregion
//#region components
import NumberFormat from "react-number-format";
import { InputBaseComponentProps } from "@mui/material";
//#endregion
import { UtilsHelper } from "utils/helpers";

const NumberFormatField: React.ForwardRefRenderFunction<{}, InputBaseComponentProps & NumberFormatCustomProps> = (
  props,
  ref
) => {
  const { onChange, defaultValue, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        const valueNum = +values.value;
        const value =
          !UtilsHelper.isEmpty(values.value) && values.value !== "-"
            ? props.allowLeadingZeros
              ? values.value
              : props.prefix?.trim() === "-" && valueNum && valueNum < 0
                ? valueNum * -1
                : valueNum
            : values.value;

        onChange({
          target: {
            name: props.name,
            value: `${value}`,
            formattedValue: values.formattedValue,
          },
        });
      }}
      type={"tel"}
      isNumericString
    />
  );
};

export default React.forwardRef(NumberFormatField);
